import React from 'react'

import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
//import SettingsIcon from '@material-ui/icons/Settings'

export const NavTopTitle = "My Anthilia"
export const NavTopImgPath = "/images/logo.png"
export const ShowUsername = false
export const DefaultLogoutButton = true
export const CustomLogoutButton = function(props) {
    return null
}

export const NavTopSchema = []

export const UserDropdownSchema = [
    {
        "slug": "profile",
        "icon": PersonOutlineIcon,
        "title": "Profile",
        "path": "/profile",
        "path_type": "internal",
    },
    /* {
        "slug": "settings",
        "icon": SettingsIcon,
        "title": "Settings",
        "path": "/settings",
        "path_type": "internal",
    }, */
]